import React from 'react';
import Posts from './Posts';

const News = () => {
  return <Posts type="News" title="The POODL Chronicle" />;
};

export default News;
